import React from 'react'
import  {withStyles } from '@material-ui/core/styles'


const style = theme =>({
    notificationWrrapper: {
        display: 'block',
        position: 'fixed',
        width:'100%',
        zIndex: '1000000',
        bottom: 0,
        left: 0,
        backgroundColor: 'rgb(63,81,181, 0.6)'
        
    },
    notificationBox: {
        width: '100%',
        marginLeft: 'auto',
        marginRight: 'auto',
        padding: theme.spacing.unit*2,
        borderTop: '8px solid white',
        borderBottom: '8px solid white',
        backgroundColor: theme.palette.primary.dark,
        color: 'white',

        

    },
    headline: {
        marginBottom: theme.spacing.unit,
        fontWeight: 'bold',
        fontSize: '1em',

    },
    content: {

    }
    
})
const Notification = ({ notification, classes }) => {
    const { headline, content } = notification
  
    return (
        <div className={classes.notificationWrrapper}>
           <div className={classes.notificationBox} >
                <div className={classes.headline} >
                    {headline}
                </div>
                <div className={classes.content} >
                    {content}
                </div>
           </div>
        </div>
    )
}

export default withStyles(style)(Notification)


// WEBPACK FOOTER //
// ./src/Container/PopUps/Notification.js